import { useApplicationContext } from '../../providers/ApplicationProvider/ApplicationProvider';

/**
 * useSession
 *
 * Custom hook to give quick access to the Session
 *
 * @returns
 */
export const useSession = () => {
    const { session } = useApplicationContext();

    return session;
};
